import {
  CheckUserRequest,
  LoginRequest,
  RefreshTokenRequest,
} from "@/types/api/login";
import lykkeClient, { authenticatedLykkeClient } from "../clients/axios";
import { UpdateUserProfile } from "@/types/api/login";
import { loginLeadFlowMetaData } from "@/types/global/common";

function isExperiencesPage(pageUrl?: string): boolean {
  const raw =
    pageUrl ??
    (typeof window !== "undefined" ? window.location.pathname : undefined);
  if (!raw) return false;

  try {
    const path = raw.startsWith("http")
      ? new URL(raw).pathname
      : raw.split("?")[0];
    return path === "/experiences" || path.startsWith("/experiences/");
  } catch {
    return raw.includes("/experiences");
  }
}

export async function checkUser(data: CheckUserRequest) {
  const response = await lykkeClient.post("/users/check-user", data);
  return response;
}

export async function login(
  data: LoginRequest,
  metadata?: loginLeadFlowMetaData
) {
  const params = new URLSearchParams();
  if (metadata) {
    Object.entries(metadata).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, String(value));
      }
    });
  }
  const queryString = params.toString();
  const url = queryString ? `/users/login?${queryString}` : "/users/login";

  // Always skip lead creation on /experiences, based on page_url only
  const payload: LoginRequest = isExperiencesPage(metadata?.page_url)
    ? { ...data, create_lead: false }
    : data;

  const response = await lykkeClient.post(url, payload);
  return response;
}

export async function refreshToken(data: RefreshTokenRequest) {
  const response = await lykkeClient.post("/users/refresh-token", data);
  return response;
}

export async function getProfile() {
  try {
    const response = await authenticatedLykkeClient.get("/users/profile");
    if (response.data.message === "Success") {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error("Failed to fetch user profile:", error);
  }
}

export async function updateUserProfile(payload: UpdateUserProfile) {
  const { data } = await authenticatedLykkeClient.post(
    `/users/update-profile`,
    payload
  );
  return data;
}
